export default __webpack_public_path__ + "static/media/chemistry.37831714.svg";